import "./Sidebar.css";

import { Layout, Menu, type MenuProps } from "antd";
import { type ReactNode } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useAppSelector } from "../../../../_store";
import { type SidebarProps } from "./Sidebar.types";
import { getActiveRoute, menuItems } from "./Sidebar.utils";

const { Sider } = Layout;

export type MenuItem = {
  key: string;
  icon: ReactNode;
  label: string;
};

export const Sidebar = ({ collapsed }: SidebarProps) => {
  const { user } = useAppSelector((state) => state.auth);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    navigate(e.key);
  };

  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      className="mainSider"
      width={250}
    >
      <div className="sidebarTop">
        <p>RiseOS Admin</p>
      </div>
      <Menu
        theme="dark"
        mode="inline"
        defaultOpenKeys={["rise-os"]}
        defaultSelectedKeys={getActiveRoute(pathname)}
        items={menuItems}
        onClick={handleMenuClick}
      />
      <div className="sidebar__footer">
        <div className="sidebar__user-info">
          <div className="sidebar__user-avatar">{user?.fullName?.[0]}</div>
          {!collapsed && (
            <div className="sidebar__user-details">
              <p className="sidebar__user-name">{user?.fullName}</p>
              <p className="sidebar__user-role">Admin</p>
            </div>
          )}
        </div>
      </div>
    </Sider>
  );
};
